import { Platform } from "./platform";
import { PlatformInfo } from "./platform-info";
import FingerprintJS from '@fingerprintjs/fingerprintjs';  
import type { PlatformType } from "./platform-type";

export abstract class PlatformUserAgent extends Platform {
    private info: PlatformInfo | null = null;

    constructor(private platformType: PlatformType) {
        super();
    }

    async getInfo(): Promise<PlatformInfo> {
        if(!this.info) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const navigator = (<any>window).navigator;
            const fingerprintService = await FingerprintJS.load({
                monitoring: false
            });
            const fingerprintObject = await fingerprintService.get();
            
            this.info = new PlatformInfo(
                this.platformType,
                fingerprintObject.visitorId, 
                navigator.userAgent, 
                fingerprintObject.visitorId);
        }

        return this.info;
    }

};